import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import useDebounce from "hooks/useDebounce";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { Link, useParams } from "react-router-dom";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";

import { Button } from "components/Button/Button";

import useMuiButtonLoader from "hooks/useMuiButtonLoader";

import {
  getBillingCoursesForMapping,
  mapBillingCourses,
} from "services/centers";

import useDataTable from "hooks/useDataTable";
import SpeedDial from "components/speed-dial/SpeedDial";
import { Fab } from "@mui/material";
import { Table } from "react-bootstrap";
import { getCityWiseBillingCourse, mapCityWiseBillingCourses } from "services/citypages";

const CityWiseBillingCoursesMapping = () => {
  const { cityid } = useParams();

  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [assignModal, setAssignModal] = useState(false);

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  const { TableHead, TableBody, selectedId, setSelectedId } = useDataTable(
    record,
    "id"
  );

  //**********billing courses Listing**********/
  const billingCourseList = async (
    page = activePage,
    search = debounceValue
  ) => {
    try {
      showLoader();
      const res = await getCityWiseBillingCourse({
        page,
        search,
        cityid: cityid,
      });
      hideLoader();
      if (res.code === 200) {
        const { billingCoures, count } = res.data;
        setRecord(billingCoures || []);
        setTotal(count || 0);
        // set default selected data
        setSelectedId([
          ...new Set([
            ...selectedId,
            ...billingCoures
              .filter((data) => data.isAssigned)
              .map((data) => data.id),
          ]),
        ]);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    setActivePage(event);
    billingCourseList(event);
  };

  //*********Handel Search************** */
  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search, 300);

  // assign function
  const assignHandler = async () => {
    // if (selectedId.length > 0) {
      try {
        setSubmitLoading(true);
        const res = await mapCityWiseBillingCourses({
          cityid: cityid,
          courseId: selectedId,
        });
        if (res.code === 200) {
          billingCourseList();
          toast.success(res.message);
          setAssignModal(false);
          setSubmitLoading(false);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    // } else {
    //   toast.error("Please select billing courses");
    // }
  };

  useEffect(() => {
    billingCourseList(activePage, debounceValue);
    // eslint-disable-next-line
  }, [debounceValue]);

  return (
    <React.Fragment>
      <title>Shubhra Viraj | City Wise Billing Courses Mapping</title>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="SearchBox">
                <div className="div_wrap">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                    name="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className="div_no_wrap mx-3"></div>
              </div>
              <h4 className="Title">
                <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                City Wise Billing Courses Mapping
              </h4>
            </div>
            <div className="TableList overflow-auto table-responsive">
              {loader}

              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>{/* <TableHead /> */}</th>
                    <th>S.No</th>
                    <th>Title</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(({ id, CourseTitle }, i) => (
                      <tr key={i}>
                        <td>
                          <TableBody
                            id={id}
                            // disabled={selectedId.length === 6}
                          />
                        </td>
                        <td>{++i + (activePage - 1) * 10}</td>
                        <td>
                          <div className="">{CourseTitle}</div>
                        </td>
                        <td></td>
                      </tr>
                    ))
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/*delete model */}
      <ModalBox
        status={assignModal}
        onClose={() => setAssignModal(false)}
        title={"Assign Billing Courses"}
        description={"Are you sure want to assign billing courses ?"}
        customizedFooter={
          <Button onClick={assignHandler} {...submitButtonElement}>
            Yes
          </Button>
        }
      />

      {/* multi select speed dial button */}
      {/* {selectedId.length > 0 && ( */}
        <SpeedDial>
          <Fab
            size="medium"
            color="primary"
            aria-label="add"
            onClick={() => setAssignModal(true)}
            sx={{ position: "absolute", bottom: 16, right: 16 }}
          >
            <AssignmentTurnedInOutlinedIcon />
          </Fab>
        </SpeedDial>
      {/* )} */}
    </React.Fragment>
  );
};

export default CityWiseBillingCoursesMapping;
